import Errors from "@shared/errors";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const initialState = () => {
    return {
        productDonationStatus: "",
        donationCart: [],
        donationTotal: 0,
        productDonationErrors: new Errors(),
        donationErrors: new Errors(),
    };
};

const state = {
    initialState: initialState,
    ...initialState(),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
